import {
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Radio,
  DatePicker,
  notification,
  Progress,
  Upload,
  Button,
  Image,
} from "antd";
import { useContext, useEffect, useState } from "react";
import UploadBanners from "../UploadBanners/index";

import "./styles.css";

import { Context } from "../../context";
import { Fetch, Post, Delete, Put } from "../../fetch";
import { convertIdToKey, handleExportClick } from "../../utils";
import {
  ExclamationCircleOutlined,
  PlusCircleTwoTone,
  UploadOutlined,
} from "@ant-design/icons";

const { Option } = Select;
const { Column } = Table;
const { TextArea } = Input;
const { confirm, info } = Modal;

const ManageVEpisodes = () => {
  const { apiUrl, token, transcodeUrl } = useContext(Context);

  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(0);
  const [seriesId, setSeriesId] = useState();
  const [episodes, setEpisodes] = useState([]);
  const [showEditEpisodeModal, setShowEditEpisodeModal] = useState(false);
  const [episode, setEpisode] = useState();
  const [modalType, setModalType] = useState();
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [uploadResponse, setUploadResponse] = useState("");
  const [uploadErrors, setUploadErrors] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    Fetch(`${apiUrl}/webseries?filterBy=all`, token, (result) => {
      const series = convertIdToKey(result?.webseries || []);
      setSeries(series);
    });
  }, [apiUrl, token, counter]);

  const handleChange = (seriesId) => {
    setSeriesId(seriesId);
    Fetch(
      `${apiUrl}/episodes?series_id=${seriesId}&filterBy=all`,
      token,
      (result) => {
        const episodes = convertIdToKey(result?.episodes || []);
        setEpisodes(episodes);
      }
    );
  };

  const handleEditEpisode = async () => {
    try {
      let values = await form.validateFields();
      values = { ...values, seriesId: seriesId };
      console.log(values);
      const fn = modalType === "Edit" ? Put : Post;
      const url =
        modalType === "Edit"
          ? `${apiUrl}/episodes/${episode.key}`
          : `${apiUrl}/episodes`;

      fn(url, token, values, (result) => {
        if (result.success === true) {
          notification.success({
            message: "Success",
            description: `Episode successfully ${
              modalType === "Edit" ? "Updated" : "Created"
            }`,
          });
          setShowEditEpisodeModal(false);
          setEpisode(null);
          form.resetFields();
          setModalType();
          handleChange(seriesId);
        } else {
        }
      });
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Error",
        description: "Required fields incorrect/missing",
      });
    }
  };

  const showAddEpisodeModal = () => {
    setModalType("Add");
    form.resetFields();
    setShowEditEpisodeModal(true);
  };

  const generateErrorResponse = (errors) => {
    return (
      <ul>
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    );
  };

  const isBulkUploadSuccess = (response) => {
    if (!response) return false;
    const success = response.success;
    return success === true || success === "True" || success === "true";
  };

  const handleUploadEpisodesCSV = () => {
    setUploadResponse("");
    setUploadErrors([]);
    setUploadModalVisible(true);
  };

  const normalizeUploadErrors = (response, fallback = "Upload failed") => {
    if (Array.isArray(response?.errors) && response.errors.length > 0) {
      return response.errors.map((error) =>
        typeof error === "string" ? error : JSON.stringify(error)
      );
    }
    const message = response?.message || response?.detail;
    if (typeof message === "string" && message) {
      return [message];
    }
    return [fallback];
  };

  const handleBulkUploadChange = (info) => {
    if (info.file.status === "uploading") {
      setUploadResponse("");
      setUploadErrors([]);
      return;
    }

    if (info.file.status === "done") {
      const response = info.file.response;

      if (isBulkUploadSuccess(response)) {
        const successMessage =
          typeof response?.message === "string"
            ? response.message
            : "Episodes uploaded successfully";

        setUploadErrors([]);
        setUploadResponse(successMessage);
        setUploadModalVisible(false);

        notification.success({
          message: "Success",
          description: successMessage,
        });

        if (seriesId) {
          handleChange(seriesId);
        }
        return;
      }

      setUploadResponse("");
      setUploadErrors(normalizeUploadErrors(response));
      return;
    }

    if (info.file.status === "error") {
      setUploadResponse("");
      setUploadErrors(
        normalizeUploadErrors(info.file.response, "Upload request failed")
      );
    }
  };

  const showEditModal = (record) => {
    setModalType("Edit");
    setEpisode(record);
    form.setFieldsValue(record);
    setShowEditEpisodeModal(true);
  };

  const showConfirmDelete = (record) => {
    confirm({
      title: "Are you sure you want to delete this episode?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        Delete(`${apiUrl}/episodes/${record.key}`, token, (result) => {
          if (result.success) {
            notification.success({
              message: "Succes",
              description: "Episode deleted successfully",
            });
            handleChange(seriesId);
          }
        });
      },
    });
  };

  return (
    <div className="manage-episodes-wrapper">
      <Select
        placeholder="Select Series"
        showSearch
        onChange={handleChange}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
      >
        {series.map((s) => (
          <Option value={s.key}>{s.title}</Option>
        ))}
      </Select>
      <Table dataSource={episodes}>
        <Column
          title="Title"
          key={"title"}
          align="center"
          dataIndex={"title"}
        />
        <Column
          title="Episode Number"
          dataIndex="episodeNo"
          key="episodeNo"
          align="center"
        />
        <Column
          title="Card Image"
          dataIndex={"thumbnailImage"}
          key="thumbnailImage"
          align="center"
          render={(_, episodes) =>
            episodes.thumbnailImage ? (
              <Image
                src={episodes.thumbnailImage}
                width={"60px"}
                height={"110px"}
              ></Image>
            ) : null
          }
        />
        <Column
          title="Actions"
          key="actions"
          align="center"
          render={(text, record) => (
            <Space size="middle">
              <a
                onClick={() => {
                  console.log("Clicked!!");
                  showEditModal(record);
                }}
              >
                Edit
              </a>
              <a onClick={() => showConfirmDelete(record)}>Delete</a>
            </Space>
          )}
        />
      </Table>

      <PlusCircleTwoTone
        twoToneColor="#FF0091"
        style={{ fontSize: "48px" }}
        className="add-series-btn"
        onClick={() => {
          showAddEpisodeModal();
        }}
      />
      <UploadOutlined
        twoToneColor="#FF0091"
        style={{ fontSize: "48px" }}
        className="add-series-btn"
        onClick={() => {
          handleUploadEpisodesCSV();
        }}
      />

      <Modal
        title={`${modalType} Episode`}
        open={showEditEpisodeModal}
        onOk={handleEditEpisode}
        okText="Submit"
        onCancel={() => setShowEditEpisodeModal(false)}
        destroyOnClose
        maskClosable={false}
      >
        <Form layout="vertical" form={form}>
          <Form.Item name={"title"} label="Title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name={"hindiTitle"}
            label="Hindi Title"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={"episodeNo"}
            label="Episode Number"
            rules={[{ required: true }]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name="thumbnailImage" label="thumbnail Image">
            <UploadBanners
              name={"thumbnailImage"}
              type="series"
              updateForm={form}
            />
          </Form.Item>
          <Form.Item name="thumbnailImageFree" label="thumbnail Image Free">
            <UploadBanners
              name={"thumbnailImageFree"}
              type="series"
              updateForm={form}
            />
          </Form.Item>
          <Form.Item name={"tcIn"} label="Start Time">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name={"tcOut"} label="End Time">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            name={"playbackUrl"}
            label="Dash URL"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={"iosPlaybackUrl"}
            label="HLS URL"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name={"tcInFree"} label="Free Start Time">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name={"tcOutFree"} label="Free End Time">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name={"playbackUrlFree"} label="Free Dash URL">
            <Input />
          </Form.Item>
          <Form.Item name={"iosPlaybackUrlFree"} label="Free HLS URL">
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Bulk Upload Episodes"
        open={uploadModalVisible}
        onCancel={() => setUploadModalVisible(false)}
        footer={null}
      >
        <Upload
          name="file"
          headers={{
            authorization: `Bearer ${token}`,
          }}
          accept="csv"
          action={`${apiUrl}/episodes/bulkUpload`}
          onChange={handleBulkUploadChange}
        >
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
        {uploadResponse && <div>{uploadResponse}</div>}
        {Array.isArray(uploadErrors) && uploadErrors.length > 0 && (
          <div>
            <h4>Errors:</h4>
            <ul>
              {uploadErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ManageVEpisodes;
